import type { ApiResponse } from './types';

/**
 * Parses the ApiResponse<T> envelope for ANY HTTP status (2xx-5xx), so callers can surface
 * backend business-rule messages (e.g. a 409 "still referenced" delete conflict, or a 400
 * validation message) instead of a generic thrown error. Only synthesises a failure envelope
 * when the response body is missing or is not valid JSON (network failure / 5xx without a body).
 */
export const parseApiResponse = async <T>(response: Response): Promise<ApiResponse<T>> => {
  const text = await response.text();
  const failure: ApiResponse<T> = { success: false, statusCode: response.status, message: `Request failed: ${response.status}` };
  if (!text) return response.ok ? { success: true, statusCode: response.status } : failure;
  try {
    const body = JSON.parse(text) as ApiResponse<T>;
    if (body && typeof body.success === 'boolean') return body;
    return response.ok ? { success: true, statusCode: response.status, result: body as unknown as T } : failure;
  } catch {
    return response.ok ? { success: true, statusCode: response.status } : failure;
  }
};
